
export class GraphhopperClustering {
  
  max_quantity : number;
  min_quantity : number;
  num_clusters : number;
}

